import { faLandmark, faUtensils, faFilm, faHeartbeat, faLaptopCode, faGem } from '@fortawesome/free-solid-svg-icons';

const industriesData = [
  {
    title: "Banking & Finance",
    icon: faLandmark,
    description: "We help banks, financial institutions, and fintech companies streamline operations with secure, technology-driven solutions."
  },
  {
    title: "Food & Hospitality",
    icon: faUtensils,
    description: "The food and hospitality industry thrives on customer satisfaction, seamless service, and memorable experiences."
  },
  {
    title: "Entertainment & Media",
    icon: faFilm,
    description: "In a fast-evolving digital era, the entertainment and media industry demands creativity, innovation, and seamless technology."
  },
  {
    title: "Healthcare & Insurance",
    icon: faHeartbeat,
    description: "Healthcare and insurance organizations face unique challenges from patient care and compliance to claims processing and data security."
  },
  {
    title: "Technology & Startups",
    icon: faLaptopCode,
    description: "We help banks, financial institutions, and fintech companies streamline operations with secure, technology-driven solutions."
  },
  {
    title: "Lifestyle Services",
    icon: faGem,
    description: "Lifestyle services are all about convenience, personalization, and improving everyday living. We support businesses in fitness, wellness, and travel."
  },
];

export default industriesData;